import React from 'react';
import {
  Box,
  Card,
  CardMedia,
  makeStyles,
} from '@material-ui/core';

import mask_bcg from '../../../../../../../../assets/video-mask-bcg.jpg';

import CustomModal from './CustomModal';


const useStyles = makeStyles((theme) => {
  return {
    video_modal: {
      width: '40%',
      [theme.breakpoints.down('sm')]: { width: '75%' },
      [theme.breakpoints.down('xs')]: { width: '95%' },
    },
    card: {
      maxWidth: '100%',
      borderRadius: '0',
      boxShadow: 'none',
      background: `url(${mask_bcg}) no-repeat center center / cover`,
    },
    media_wrapper: {
      position: 'relative',
      height: '400px',
      width: '100%',
      [theme.breakpoints.down('xs')]: { height: '200px' },
    },
    card_media: {
      height: '100%',
      margin: 'auto',
    },
  };
});

const VideoModal = ({ url, onClose }) => {
  const classes = useStyles();

  return (
    <CustomModal
      contentClassName={classes.video_modal}
      hideCloseIcon={true}
      open={true}
      onClose={onClose}
    >
      <Box mx="auto" textAlign="left">
        <Card className={classes.card}>
          <Box className={classes.media_wrapper}>
            <CardMedia
              autoPlay={true}
              className={classes.card_media}
              component="video"
              controls={true}
              controlsList="nodownload"
              crossOrigin="anonymous"
              disablePictureInPicture={true}
              src={url}
            />
          </Box>
        </Card>
      </Box>
    </CustomModal>
  );
};

export default VideoModal;
